// extracted by mini-css-extract-plugin
export var bubble = "_3u-0";
export var container = "_3u-3";
export var contrastBorder = "_3u-4";
export var greyOut = "_3u-2";
export var initialsWrapper = "_3u-1";
export var large = "_3u-9";
export var medium = "_3u-8";
export var mediumSmall = "_3u-7";
export var mediumSmallMedium = "_3u-c";
export var micro = "_3u-5";
export var small = "_3u-6";
export var tiny = "_3u-b";
export var xTiny = "_3u-a";